// Authorization section form field enum
export enum AuthorizationFormField {
  AUTHORIZATION_AUTHORIZATION_AUTHORIZATION_SOURCE = 'authorization/authorization/authorization-source',
  AUTHORIZATION_REQUESTED_HOURS = 'authorization/authorization/requested-hours'
}
